import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  arrezoUploadExcelRequest,
  arrezoUploadExcelResponse,
  ReentregaLoteConsultaRequest,
  ReentregaLoteConsultaResponse,
  ReentregaLoteSelecionarInconsistenciaResponse,
  ReentregaLoteSelecionarInconsistenciasRequest,
  ReentregaLoteUploadExcelRequest,
  ReentregaLoteUploadExcelResponse
} from 'src/app/@shared/models/reentrega-lote/reentrega-lote.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const filtro = (obj: ReentregaLoteSelecionarInconsistenciasRequest | ReentregaLoteConsultaRequest) => {
  const filtro = Object.entries(obj).filter(([k, v]) => v);
  return new URLSearchParams(filtro);
}

@Injectable({
  providedIn: 'root'
})
export class ReentregaLoteService {

  constructor(private http: HttpClient) { }

  comboRotina(): Observable<any> {
    return this.http
      .get<any>('ReentregaLote/ComboRotina', httpOptions);
  }

  consultaReentregaLote(obj: ReentregaLoteConsultaRequest): Observable<ReentregaLoteConsultaResponse[]> {
    console.log('objservico', obj)
    return this.http.get<ReentregaLoteConsultaResponse[]>(
      `ReentregaLote/ConsultaReentrega?${filtro(obj)}`,
      httpOptions
    );
  }

  getClientsList(): Observable<any> {
    return this.http.get<any>('IntegradorCliente/Get', httpOptions);
  }

  uploadExcelReentregaLote(obj: ReentregaLoteUploadExcelRequest):
    Observable<ReentregaLoteUploadExcelResponse> {
    return this.http.put<ReentregaLoteUploadExcelResponse>(
      'ReentregaLote/UploadExcelReentregaLote',
      obj,
      httpOptions
    );
  }

  uploadExcelArrezo(obj: arrezoUploadExcelRequest):
  Observable<arrezoUploadExcelResponse> {
  return this.http.put<arrezoUploadExcelResponse>(
    'TANFe/ImportarTANFe',
    obj,
    httpOptions
  );
}

  public exportarExcel(obj: ReentregaLoteConsultaRequest): Observable<any> {
    return this.http.get<any>(`ReentregaLote/ExportarExcel?${filtro(obj)}`, httpOptions);
  }

  public downloadTemplate(): Observable<any> {
    return this.http.get<any>(`ReentregaLote/DownloadTemplatePlanilha`, httpOptions);
  }

  public downloadTemplateExcelArezzo(): Observable<any> {
    return this.http.get<any>(`TANFe/DownloadTemplatePlanilha`, httpOptions);
  }

  selecionarInconsistencias(obj: ReentregaLoteSelecionarInconsistenciasRequest):
    Observable<ReentregaLoteSelecionarInconsistenciaResponse[]> {
    return this.http.get<ReentregaLoteSelecionarInconsistenciaResponse[]>(
      `ReentregaLote/SelecionarInconsistencias?${filtro(obj)}`,
      httpOptions
    );
  }
}
